/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react'
import { useEventListener } from 'usehooks-ts'

export const useTop = (): boolean => {
  const [top, setTop] = useState(window.scrollY <= 0)

  const scrollListener = () => {
    if (window.scrollY <= 0) {
      setTop(true)
    } else {
      setTop(false)
    }
  }

  useEventListener('scroll', scrollListener, undefined, { passive: true })

  return top
}
